<script>
  import Vue from 'vue';
  import CheckCashoutService from '@/services/mybets/check-cashout-service';
  import CashoutService from '@/services/mybets/cashout-request-service';
  import { CASHOUT_ON_DEMAND_STEPS } from '@/models/enums/mybets-const';
  import { formatCurrency } from '@bto-services/utils';

  const { INITAL, LOADING, CONFIRM, CASHING_OUT, NEW_OFFER, UNAVAILABLE, DISABLED } = CASHOUT_ON_DEMAND_STEPS;
  const generateConfirmStringKey = (step, amount) => {
    switch (step) {
      case CONFIRM:
        return `${Vue.prototype.$translate.text('M.CashoutConfirm')} ${formatCurrency(amount)}`;
      case NEW_OFFER:
        return `${Vue.prototype.$translate.text('M.CashoutNewOffer')} ${formatCurrency(amount)}`;
      case UNAVAILABLE:
        return Vue.prototype.$translate.text('M.CashoutSuspended');
    }
    return '';
  };
  export default {
    functional: true,
    name: 'CashoutOnDemand',
    props: {
      cashoutStep: {
        type: Number,
        default: INITAL,
      },
      betId: {
        type: Number,
        required: true,
      },
      isMobile: {
        type: Boolean,
        default: false,
      },
      cashoutAmount: {
        type: Number,
        required: true,
      },
    },
    render(h, { props, listeners }) {
      const { cashoutStep, betId, isMobile, cashoutAmount } = props;
      const emptyCb = () => { };
      const tagName = isMobile ? 'a' : 'button';
      const formBtnClass = isMobile ? 'bto-sb-mb-form-btn' : 'bto-sb-form-btn';
      const cashoutGreenClass = isMobile ? 'bto-sb-mb-mybet-btn-cashout' : 'bto-sb-form-btn-green';
      const cashoutLoaderClass = isMobile ? 'bto-sb-mb-cashout-loader' : 'bto-sb-loader';
      const confirmClass = isMobile ? 'bto-sb-mb-mybet-btn-cashout bto-sb-mb-mybet-btn-cashout-confirm' : 'bto-sb-mybet-cashout-confirm';
      const clearClass = isMobile ? 'bto-sb-mb-mybet-btn-cashout-clear' : 'bto-sb-mybet-cashout-confirm';
      const confirmStringKey = generateConfirmStringKey(cashoutStep, cashoutAmount);

      const createConfirmNodes = [
        h(tagName, {
          class: [formBtnClass, confirmClass],
          on: {
            click: () => {
              if (cashoutStep === UNAVAILABLE) {
                return;
              }
              const changeStep = listeners.changeStep || emptyCb;
              let cashoutService = new CashoutService(cashoutAmount, betId);
              cashoutService.execute();
              changeStep(CASHING_OUT);
            },
          },
          domProps: {
            innerHTML: confirmStringKey,
          },
        }),
        h(tagName, {
          class: [formBtnClass, clearClass],
          on: {
            click: () => {
              const changeStep = listeners.changeStep || emptyCb;
              changeStep(INITAL);
            },
          },
        }, [h('i', { staticClass: 'bto-app-delete' })]),
      ];
      const createNodes = () => {
        switch (cashoutStep) {
          case INITAL:
            return h(tagName, {
              class: [formBtnClass, cashoutGreenClass],
              on: {
                click: () => {
                  const changeStep = listeners.changeStep || emptyCb;
                  changeStep(LOADING);
                  const checkCashoutRequest = new CheckCashoutService(betId);
                  checkCashoutRequest.execute((resp) => {
                    if (resp.data.CashoutValue > 0) {
                      const changeAmount = listeners.changeAmount || emptyCb;
                      changeAmount({ amount: resp.data.CashoutValue, step: CONFIRM });
                    } else {
                      const changeMsg = listeners.changeMsg || emptyCb;
                      changeStep(DISABLED);
                      changeMsg({
                        type: 'warning',
                        text: Vue.prototype.$translate.text('A.CashoutUnavailable'),
                      });
                    }
                  }, (error) => {
                    const changeMsg = listeners.changeMsg || emptyCb;
                    changeStep(DISABLED);
                    changeMsg({
                      type: 'warning',
                      text: Vue.prototype.$translate.text('A.CashoutUnavailable'),
                    });
                    console.warn(error); // eslint-disable-line
                  });
                },
              },
              domProps: {
                innerHTML: Vue.prototype.$translate.text('Mobile.cashout'),
              },
            });
          case LOADING:
          case CASHING_OUT:
            return h(
              tagName,
              {
                class: [formBtnClass, cashoutGreenClass, 'bto-sb-mybets-cashout-load'],
              },
              [
                h('i', { staticClass: cashoutLoaderClass }),
                h('span', { domProps: { innerHTML: Vue.prototype.$translate.text(cashoutStep === LOADING ? 'A.Loading' : 'M.CashoutConfirmed') } }),
              ]);
          case CONFIRM:
          case NEW_OFFER:
          case UNAVAILABLE:
            return isMobile ? createConfirmNodes : h('div', { staticClass: 'bto-sb-form-btn-group' }, createConfirmNodes);
          case DISABLED:
            return h(tagName, { class: [formBtnClass, cashoutGreenClass, 'bto-sb-form-btn-disabled'], domProps: { innerHTML: Vue.prototype.$translate.text('Mobile.cashout') } });
        }
      };
      return createNodes();
    }
  };
</script>